import styled from "styled-components";
import { Loader } from 'semantic-ui-react';

export const Container = styled.div`
  padding: 1rem 1rem 5rem;
  background: transparent;
  h2 {
    text-align: left;
    width: 100%;
    padding: 1rem 0;
  }
`;
